import { useAuth0 } from '@auth0/auth0-react';
import { useMutation } from '@tanstack/react-query';

import { importBulkOperation } from '../apis/bulkOperationApi';

import { useInvalidateBulkOperation } from './useInvalidateImport';

/**
 * Hook for importing all generated bookings in a bulk operation (async, returns 202)
 */
export const useImportAllBookings = (bulkOperationId: string) => {
  const { getAccessTokenSilently } = useAuth0();
  const { invalidateAll } = useInvalidateBulkOperation(bulkOperationId);

  const importAllMutation = useMutation({
    mutationFn: async () => {
      const token = await getAccessTokenSilently();
      return importBulkOperation(bulkOperationId, token);
    },
    onSuccess: () => {
      invalidateAll();
    },
  });

  return {
    importAllBookings: importAllMutation.mutateAsync,
    isImportingAll: importAllMutation.isPending,
  };
};
